import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../Utilities/Footer';
import Header from '../Utilities/Header';

const InvestorGrievance = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace('#', '');
            const el = document.getElementById(id);
            if (el) {
                setTimeout(() => {
                    el.scrollIntoView({ behavior: 'smooth' });
                }, 100); // Delay to ensure element is mounted
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);

    return (
        <>
            <Header />
            <div id="investorgrievance" className="privacy">
                <div className="page-title">
                    <h4>Wise Finserv - Investor Grievance</h4>
                </div>
                <div className="privacy-body">
                    <h5>
                        To register a formal complaint with Wise Finserv Pvt. Ltd., please write to &nbsp;
                        <a href="mailto:compliance@wisefinserv.com">compliance@wisefinserv.com</a>&nbsp;with your:
                    </h5>
                    <ol>
                        <li>Full Name</li>
                        <li>Registered Mobile Number</li>
                        <li>Pan Card</li>
                        <li>Nature of Complaint</li>
                    </ol>
                    <h5>
                        Investors, who are not satisfied with the resolution provided by client service team, may escalate
                        the matter to following officials as per the below escalation matrix:
                    </h5>
                    <p>
                        <strong>Level 1</strong> – Contact Ms. Shalvi Chawla, Head - Operations &amp; Customer Service at&nbsp;
                        <a href="mailto:shalvichawla@wisefinserv.com">shalvichawla@wisefinserv.com</a> or call 0120-4114832
                    </p>
                    <p>
                        <strong>Level 2</strong> – Contact Ms. Charu Pahuja, Director &amp; COO at&nbsp;
                        <a href="mailto:charupahuja@wisefinserv.com">charupahuja@wisefinserv.com</a>
                    </p>
                    <p>
                        <strong>Level 3</strong> – Contact Mr. Ajay Kumar Yadav, CEO at&nbsp;
                        <a href="mailto:ajay.yadav@wisefinserv.com">ajay.yadav@wisefinserv.com</a>
                    </p>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default InvestorGrievance;
